module.exports = __webpack_public_path__ + "static/media/build.5b6c6324.jpeg";